"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appSelectControlById_1 = __importDefault(require("./appSelectControlById"));
const controlIsLegacy_1 = __importDefault(require("./controlIsLegacy"));
const appSelectControlParentById = ({ buildOrders, controlId, flattedControls, }) => {
    const control = (0, appSelectControlById_1.default)({
        buildOrders,
        controlId,
        flattedControls,
    });
    if (!control) {
        return undefined;
    }
    const controlInfo = flattedControls[controlId];
    if (controlInfo === null || controlInfo === void 0 ? void 0 : controlInfo.parentControlId) {
        return (0, appSelectControlById_1.default)({
            buildOrders,
            controlId: controlInfo.parentControlId,
            flattedControls,
        });
    }
    const parentInfo = Object.values(flattedControls).find((info) => {
        const infoControls = info === null || info === void 0 ? void 0 : info.control.controls;
        if (!infoControls) {
            return false;
        }
        return infoControls.some((child) => !(0, controlIsLegacy_1.default)(child) && child === controlId);
    });
    if (!parentInfo) {
        return undefined;
    }
    return (0, appSelectControlById_1.default)({
        buildOrders,
        controlId: parentInfo.control.id,
        flattedControls,
    });
};
exports.default = appSelectControlParentById;
